import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Tooltip from '@material-ui/core/Tooltip';

const AssetPublishInfo = ({
    hasChangesAfterLastPublish,
    embedURL,
    classes,
}) => {
    if (!embedURL) {
        return null;
    }

    const extraTip = hasChangesAfterLastPublish ? '(has changes)' : '';

    return (
        <Tooltip placement="left" title={`View published version ${extraTip}`}>
            <a target="_blank" href={embedURL} className={classes.wrapper}>
                <i className="material-icons">public</i>
            </a>
        </Tooltip>
    );
};

AssetPublishInfo.propTypes = {
    embedURL: PropTypes.string,
    hasChangesAfterLastPublish: PropTypes.bool,
};

AssetPublishInfo.defaultProps = {
    embedURL: undefined,
    hasChangesAfterLastPublish: false,
};

const style = ({ palette, spacing }) => ({
    wrapper: {
        width: spacing.unit * 6,
        height: spacing.unit * 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        color: palette.action.active,
        '&:hover': {
            color: palette.text.secondary,
        },
    },
});

export default injectSheet(style)(AssetPublishInfo);



// WEBPACK FOOTER //
// ./src/components/assets/AssetPublishInfo.js